.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.submit {
  align-self: flex-start;
}
